import * as yup from 'yup'

const liquidatorEntityValidationScheme = yup.object().shape({
    companyName: yup
        .string()
        .required('Le nom de l\'entreprise est requis')
        .min(2, 'Le nom doit faire au moins 2 caractères'),
    postalCode: yup
        .string()
        .required('Le code postal est requis')
        .matches(/^\d{5}$/, 'Le code postal doit contenir 5 chiffres'),
    city: yup.string().required('La ville est requise'),
    address: yup.string().required('L\'adresse est requise'),
});

export default liquidatorEntityValidationScheme;